import { render } from "./ExpresswayLogo.vue?vue&type=template&id=7899c956"
const script = {}
script.render = render

export default script